module.exports = __webpack_public_path__ + "assets/media/wordpress-text-logo.79c0a8b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/OnboardingInstallStep/WordPressInstall/wordpress-text-logo.svg
// module id = 2903
// module chunks = 0